<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Toko</a></li>
                <li><a href="#/toko">Master Data</a></li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
                          <h4><b>MASTER DATA</b></h4>
                        </div>                        
                        <div class="pull-right" style="padding-right: 20px; padding-top: 10px" v-if="level === 'ROOT'">
                          <el-button icon="el-icon-plus" type="success" @click="addData()" size="small"></el-button>
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal" border hover
                          :data="tableData1"
                          style="width: 100%" max-height="550" responsive>
                          <el-table-column fixed="left"
                            label="#"
                            header-align="center"
                            align="center"
                            width="50px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                <!-- {{scope.row.no}}. -->
                                {{ scope.row.kode }}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="NAMA TOKO"
                            prop="nama"
                            header-align="left"
                            align="left">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_nama" placeholder="Filter Toko" @keyup.native="cariNama()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.nama }}</span>
                            </template>
                          </el-table-column>
                          <!-- <el-table-column
                            label="REGION"
                            prop="region"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_region" placeholder="Filter Region" @keyup.native="cariRegion()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.region }}</span>
                            </template>
                          </el-table-column> -->
                          <el-table-column
                            label="WILAYAH"
                            prop="wilayah"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_wilayah" placeholder="Filter Wilayah" @keyup.native="cariWilayah()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.wilayah }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="STATUS"
                            prop="status"
                            header-align="center"
                            align="center"
                            width="80px">
                            <template slot-scope="scope">
                              {{ scope.row.status }}
                            </template>
                          </el-table-column>
                          <!--<el-table-column
                            label="AREA"
                            prop="area"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_area" placeholder="Filter Area" @keyup.native="cariArea()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.area }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="CABANG"
                            prop="cabang"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_cabang" placeholder="Filter Cabang" @keyup.native="cariCabang()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.cabang }}</span>
                            </template>
                          </el-table-column> -->
                          <!-- <el-table-column
                            label="ALAMAT"
                            prop="alamat"
                            header-align="left"
                            align="left"
                            width="300px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_alamat" placeholder="Filter Alamat" @keyup.native="cariAlamat()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.alamat }}</span>
                            </template>
                          </el-table-column> -->
                          <!-- <el-table-column
                            label="JENIS"
                            prop="jenis_toko"
                            header-align="left"
                            align="left"
                            width="150px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_jenis_toko" placeholder="Filter Jenis Toko" @keyup.native="cariJenisToko()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.jenis_toko }}</span>
                            </template>
                          </el-table-column> -->
                          <!-- <el-table-column
                            label="ADMIN TOKO"
                            prop="admin"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_admin" placeholder="Filter Admin" @keyup.native="cariAdmin()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.admin }} <span><el-button type="primary" size="mini" icon="el-icon-edit"  @click="editAdmin(scope.row)"></el-button></span></span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="ADMIN GUDANG"
                            prop="admin_area"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_admin_area" placeholder="Filter Admin AdmArea" @keyup.native="cariAdminAdmArea()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.admin_area }} <span><el-button type="primary" size="mini" icon="el-icon-edit"  @click="editAdmArea(scope.row)"></el-button></span></span>
                            </template>
                          </el-table-column> -->
                          <!-- <el-table-column
                            label="KEPALA REGION"
                            prop="kepala_region"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_kepala_region" placeholder="Filter Kepala Region" @keyup.native="cariKareg()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.kepala_region }} </span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="KEPALA WILAYAH"
                            prop="kepala_wilayah"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_kepala_wilayah" placeholder="Filter Kepala Wilayah" @keyup.native="cariKawil()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.kepala_wilayah }} </span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="KEPALA AREA"
                            prop="kepala_area"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_kepala_area" placeholder="Filter Kepala Area" @keyup.native="cariKarea()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.kepala_area }} </span>
                            </template>
                          </el-table-column> -->
                          <!-- <el-table-column
                            label="KEPALA CABANG"
                            prop="kacab"
                            header-align="left"
                            align="left"
                            width="250px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_kacab" placeholder="Filter Kepala Cabang" @keyup.native="cariKacab()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.kacab }} </span>
                            </template>
                          </el-table-column> -->
                          <!-- <el-table-column
                            label="PAJAK"
                            prop="pajak"
                            header-align="center"
                            align="center"
                            width="80px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_pajak" placeholder="Filter Pajak" @keyup.native="cariPajak()"></el-input>
                              </template>
                              <span v-else>{{ toMoney(scope.row.pajak) }} % </span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="ROYALTI"
                            prop="royalti"
                            header-align="center"
                            align="center"
                            width="100px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_royalti" placeholder="Filter Royalti" @keyup.native="cariRoyalti()"></el-input>
                              </template>
                              <span v-else>{{ toMoney(scope.row.royalti) }} % </span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="INVESTASI"
                            prop="investasi"
                            header-align="left"
                            align="left"
                            width="200px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{ toMoney(scope.row.investasi_pembangunan) }}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="SEWA TOKO"
                            prop="sewa_toko"
                            header-align="left"
                            align="left"
                            width="200px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{ toMoney(scope.row.sewa_toko) }}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="JATUH TEMPO"
                            prop="jatuh_tempo"
                            header-align="left"
                            align="left"
                            width="200px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.jatuh_tempo_sewa_toko}}
                              </template>
                            </template>
                          </el-table-column>                          
                          <el-table-column
                            label="JENIS CUTOFF"
                            prop="cutoff_jenis_nama"
                            header-align="left"
                            align="left"
                            width="200px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.cutoff_jenis_nama}}
                              </template>
                            </template>
                          </el-table-column> -->

                          <el-table-column fixed="right" label="PILIHAN" align="center" header-align="center" width="150px"> <!-- width="300px" -->
                            <template slot-scope="scope">
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Detail" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-search"  @click="confirmEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Buka" placement="top-start">
                                <el-button type="warning" size="small" icon="el-icon-refresh"  @click="confirmOpen(scope.row)"></el-button>
                              </el-tooltip>
                              <!-- <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Hapus" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete" @click="confirmDel(scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Pegawai" placement="top-start">
                                <el-button type="warning" size="small" icon="ti-user"  @click="confirmEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Investor" placement="top-start">
                                <el-button type="success" size="small" icon="ti-money"  @click="confirmEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Device POS" placement="top-start">
                                <el-button type="info" size="small" icon="ti-mobile"  @click="confirmEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip> -->
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog title="Tambah Data" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd" width="500px" top="1%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama"></el-input>
                    </el-form-item>
                    <el-form-item label="Alamat" prop="alamat">
                      <el-input type="text" v-model="row1.alamat"></el-input>
                    </el-form-item>
                    <el-form-item label="Region" prop="kode_region">
                      <el-autocomplete
                        class="inline-input"
                        v-model="region1_"
                        :fetch-suggestions="querySearchRegion"
                        placeholder="Cari Region"
                        @select="handleSelectRegion"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Wilayah" prop="kode_wilayah">
                      <el-autocomplete
                        class="inline-input"
                        v-model="wilayah1"
                        :fetch-suggestions="querySearchWilayah"
                        placeholder="Cari Wilayah"
                        @select="handleSelectWilayah"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Area" prop="kode_area">
                      <el-autocomplete
                        class="inline-input"
                        v-model="area1"
                        :fetch-suggestions="querySearchArea"
                        placeholder="Cari Area"
                        @select="handleSelectArea"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Cabang" prop="kode_cabang">
                      <el-autocomplete
                        class="inline-input"
                        v-model="cabang1"
                        :fetch-suggestions="querySearch1"
                        placeholder="Cari Cabang"
                        @select="handleSelect_1"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Toko Jenis" prop="kode_toko_jenis">
                      <el-autocomplete
                        class="inline-input"
                        v-model="region1"
                        :fetch-suggestions="querySearch"
                        placeholder="Cari Jenis Toko"
                        @select="handleSelect_"
                      ></el-autocomplete>
                    </el-form-item>                    
                    <!-- <el-form-item label="Pajak" prop="pajak">
                      <el-select v-model="row1.keterangan_pajak" placeholder="Pilih Pajak">
                        <el-option
                          v-for="item in pajak"
                          :key="item.kode"
                          :label="item.value"
                          :value="item.kode">
                        </el-option>
                      </el-select>
                    </el-form-item>                     -->
                    <el-form-item label="Pajak" prop="kode_pajak">
                      <el-select v-model="keterangan_pajak" @change="ubahKodePajak" placeholder="Pilih Pajak">
                        <el-option
                          v-for="item in pajak"
                          :key="item.kode"
                          :label="item.value"
                          :value="item.kode ">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="Pajak" prop="pajak">
                      <el-input type="text" v-model="row1.pajak"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="Royalti" prop="royalti">
                      <el-input type="text" v-model="row1.royalti"></el-input>
                    </el-form-item> -->
                    <el-form-item label="Investasi Pembangunan Toko" prop="investasi_pembangunan">
                      <el-input type="text" v-model="row1.investasi_pembangunan"></el-input>
                    </el-form-item>
                    <el-form-item label="Sewa Toko" prop="sewa_toko">
                      <el-input type="text" v-model="row1.sewa_toko"></el-input>
                    </el-form-item>
                    <el-form-item label="Tanggal Jatuh Tempo" prop="jatuh_tempo_sewa_toko">
                      &emsp;
                      <el-date-picker
                        v-model="value4" style="width: 140px"
                        type="date">
                      </el-date-picker>
                    </el-form-item>

                    <el-form-item label="Jenis Cutoff" prop="cutoff_jenis_kode">
                      <el-autocomplete
                        class="inline-input"
                        v-model="cutoff_jenis_nama"
                        :fetch-suggestions="querySearchJenis"
                        placeholder="Cari Jenis Cutoff"
                        @select="handleSelectJenis"
                      ></el-autocomplete>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Edit Data" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="500px" top="1%">
                  <el-form label-position="top" :model="row1" status-icon :rules="rules3" ref="formEdit" @submit.prevent="">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama"></el-input>
                    </el-form-item>
                    <el-form-item label="Alamat" prop="alamat">
                      <el-input type="text" v-model="row1.alamat"></el-input>
                    </el-form-item>
                    <el-form-item label="Region" prop="kode_region">
                      <el-autocomplete
                        class="inline-input"
                        v-model="region1_"
                        :fetch-suggestions="querySearchRegion"
                        placeholder="Cari Region"
                        @select="handleSelectRegion"
                        :disabled="level.indexOf('ADMIN') !== -1"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Wilayah" prop="kode_wilayah">
                      <el-autocomplete
                        class="inline-input"
                        v-model="wilayah1"
                        :fetch-suggestions="querySearchWilayah"
                        placeholder="Cari Wilayah"
                        @select="handleSelectWilayah"
                        :disabled="level.indexOf('ADMIN') !== -1"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Area" prop="kode_area">
                      <el-autocomplete
                        class="inline-input"
                        v-model="area1"
                        :fetch-suggestions="querySearchArea"
                        placeholder="Cari Area"
                        @select="handleSelectArea"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Cabang" prop="kode_cabang">
                      <el-autocomplete
                        class="inline-input"
                        v-model="cabang1"
                        :fetch-suggestions="querySearch1"
                        placeholder="Cari Cabang"
                        @select="handleSelect_1"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Toko Jenis" prop="kode_toko_jenis">
                      <el-autocomplete
                        class="inline-input"
                        v-model="region1"
                        :fetch-suggestions="querySearch"
                        placeholder="Cari Jenis Toko"
                        @select="handleSelect_"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Pajak" prop="kode_pajak">
                      <el-select v-model="keterangan_pajak" @change="ubahKodePajak" placeholder="Pilih Pajak">
                        <el-option
                          v-for="item in pajak"
                          :key="item.kode"
                          :label="item.value"
                          :value="item.kode ">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <!-- <el-form-item label="Pajak" prop="pajak">
                      <el-input type="text" v-model="row1.pajak"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="Royalti" prop="royalti">
                      <el-input type="text" v-model="row1.royalti"></el-input>
                    </el-form-item> -->
                    <el-form-item label="Investasi Pembangunan Toko" prop="investasi_pembangunan">
                      <el-input type="text" v-model="row1.investasi_pembangunan"></el-input>
                    </el-form-item>
                    <el-form-item label="Sewa Toko" prop="sewa_toko" style="float: none">
                      <el-input type="text" v-model="row1.sewa_toko" style="width: 275px"></el-input>
                      <el-date-picker
                        v-model="value4" style="width: 140px"
                        type="date">
                      </el-date-picker>
                    </el-form-item>                    
                    <!-- <el-form-item label="Jatuh Tempo Sewa toko" prop="jatuh_tempo_sewa_toko">
                      &emsp;
                      <el-date-picker
                        v-model="value4" style="width: 140px"
                        type="date">
                      </el-date-picker>
                    </el-form-item> -->

                    <el-form-item label="Jenis Cutoff" prop="cutoff_jenis_kode">
                      <el-autocomplete
                        class="inline-input"
                        v-model="cutoff_jenis_nama"
                        :fetch-suggestions="querySearchJenis"
                        placeholder="Cari Jenis Cutoff"
                        @select="handleSelectJenis"
                      ></el-autocomplete>
                    </el-form-item>
                    <el-form-item label="Admin Toko" prop="admin">
                      <el-input type="text" v-model="row1.admin" style="width: 370px"></el-input>
                      <el-button type="warning" size="small" icon="ti-user" @click="editAdmin2()" v-if="level === 'ROOT'"></el-button>
                    </el-form-item>
                    <el-form-item label="Admin Area" prop="admin">
                      <el-input type="text" v-model="row1.admin_area" style="width: 370px"></el-input>
                      <el-button type="warning" size="small" icon="ti-user" @click="editAdmArea2()" v-if="level === 'ROOT'"></el-button>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">Tutup</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')" v-if="(level === 'ROOT' || level === 'ADMIN TOKO')">Simpan Perubahan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Pilih Admin" :visible.sync="dialogFormEditAdmin" v-loading="loadingModalEditAdmin" width="500px" top="1%">
                  <el-input
                    v-model="carinama"
                    placeholder="Cari Admin"
                    @keyup.native="handleSelect"
                  ></el-input>&nbsp;
                  <el-table v-loading="loadingModalAdmin" border hover
                    :data="admin"
                      highlight-current-row
                      @current-change="handleCurrentChangeAdmin"
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="#"
                      min-width="50">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="Nama"
                      min-width="300">
                      <template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
                    </el-table-column>
                  </el-table>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEditAdmin = false">Tutup</el-button>
                      <el-button type="primary" @click="confirmEditAdmin1(0, row1, 'formEditAdmin')" v-if="level === 'ROOT'">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Edit Admin Area" :visible.sync="dialogFormEditAdmArea" v-loading="loadingModalEditAdmArea" width="500px" top="1%">
                  <el-input
                    v-model="carinama1"
                    placeholder="Cari Admin Area"
                    @keyup.native="handleSelect1"
                  ></el-input>&nbsp;
                  <el-table v-loading="loadingModalAdmArea" border hover
                    :data="admarea"
                      highlight-current-row
                      @current-change="handleCurrentChangeAdmArea"
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="#"
                      min-width="50">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="Nama"
                      min-width="300">
                      <template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
                    </el-table-column>
                  </el-table>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEditAdmArea = false">Tutup</el-button>
                      <el-button type="primary" @click="confirmEditAdmArea1(0, row1, 'formEditAdmArea')" v-if="level === 'ROOT'">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Edit Kacab" :visible.sync="dialogFormEditKacab" v-loading="loadingModalEditKacab" width="500px" top="1%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formEditKacab" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama" disabled></el-input>
                    </el-form-item>
                  </el-form>
                  <div class="pull-right">
                      Search &nbsp;
                    <el-input
                      v-model="carinama2"
                      placeholder="Cari Kacab"
                      @keyup.native="handleSelect2"
                    ></el-input>
                  </div>
                  <el-table v-loading="loadingModalKacab" border hover
                    :data="kacab"
                      highlight-current-row
                      @current-change="handleCurrentChangeKacab"
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="#"
                      min-width="50">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}
                      </template>
                    </el-table-column>
                    <el-table-column fixed="left"
                      label="Nama"
                      min-width="300">
                      <template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
                    </el-table-column>
                  </el-table>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEditKacab = false">Tutup</el-button>
                      <el-button type="primary" @click="confirmEditKacab1(0, row1, 'formEditKacab')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormOpen" v-loading="loadingModalOpen" width="500px" top="1%">
                  <h4>Apakah Anda yakin akan membuka kembali toko <b>{{ nama }}</b> ?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormOpen = false">Batal</el-button>
                    <el-button type="primary" @click="confirmOpen1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="500px" top="1%">
                  <h4>Apakah Anda yakin akan menghapus toko {{ nama }}?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Info" :visible.sync="dialogFormInfo" width="500px" top="1%">
                  <h5>{{message}}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>
                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    import moment from 'moment'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    export default {
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          index_msg: 0,
          level: localStorage.level,
          region1: '',
          region1_: '',
          wilayah1: '',
          area1: '',
          cabang1: '',
          row1: {kode: '', nama: '', edit: true},
          tableData: [],
          links: [],
          tableData1: [],
          tableData2: [],
          notif: [],
          pajak: [],
          v_status: [
            {
              kode: 0,
              value: 'TIDAK'
            },
            {
              kode: 1,
              value: 'AKTIF'
            }
          ],
          carinama: '',
          carinama1: '',
          carinama2: '',
          cutoff_jenis_kode: '',
          cutoff_jenis_nama: '',
          kode_pajak: '',
          keterangan_pajak: '',
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_nama: '',
          cari_region: '',
          cari_kacab: '',
          cari_pajak: '',
          cari_royalti: '',
          cari_kepala_region: '',
          cari_kepala_wilayah: '',
          cari_kepala_area: '',
          cari_admin: '',
          cari_alamat: '',
          cari_area: '',
          cari_cabang: '',
          cari_wilayah: '',
          cari_admin_area: '',
          cari_jenis_toko: '',
          nama: '',
          region: [],
          region_: [],
          wilayah: [],
          wilayah_: [],
          area: [],
          area_: [],
          cabang: [],
          cabang_: [],
          admin: [],
          admin1: [],
          admarea: [],
          admarea1: [],
          kacab: [],
          kacab1: [],
          coba: false,
          dialogFormEdit: false,
          dialogFormEditAdmin: false,
          dialogFormEditAdmArea: false,
          dialogFormEditKacab: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalEditAdmin: false,
          loadingModalEditAdmArea: false,
          loadingModalEditKacab: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          loadingModalOpen: false,
          dialogFormOpen: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          value4: new Date(),
          formLabelWidth: 'auto',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama toko', trigger: 'blur' }
            ],
            alamat: [
              { required: true, message: 'Silahkan isi alamat toko', trigger: 'blur' }
            ],
            // kode_pajak: [
            //   { required: true, message: 'Silahkan isi pajak toko', trigger: 'blur' }
            // ],
            // royalti: [
            //   { required: true, message: 'Silahkan isi royalti toko', trigger: 'blur' }
            // ],
            kode_cabang: [
              { required: true, message: 'Silahkan isi cabang toko', trigger: 'change' }
            ],
            kode_toko_jenis: [
              { required: true, message: 'Silahkan isi jenis toko', trigger: 'change' }
            ],
            investasi_pembangunan: [
              { required: true, message: 'Silahkan isi biaya investasi pembangunan', trigger: 'blur' }
            ],
            sewa_toko: [
              { required: true, message: 'Silahkan isi biaya sewa toko', trigger: 'blur' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Toko A-Z', key: '+nama' }, { label: 'Toko Z-A', key: '-nama' }],
          total: null,
          page_size: 6,
          current_page: 1,
          kode: ''
        }
      },
      methods: {
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        openNotif () {
          var msg = this.notif[this.index_msg].message
          this.$notify({
            title: 'Peringatan',
            message: msg,
            type: 'warning',
            duration: 0,
            offset: 50
          })
          this.index_msg++
        },
        ubahKodePajak (item) {
          this.row1.kode_pajak = item
        },
        querySearch: function (queryString, cb) {
          var links = this.region.slice()
          var results = queryString ? links.filter(this.createFilter(queryString)) : links
          cb(results)
        },
        createFilter (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect_ (item) {
          this.row1.kode_toko_jenis = item.kode
        },
        querySearch1: function (queryString, cb) {
          var links = this.cabang_.slice()
          var results = queryString ? links.filter(this.createFilter1(queryString)) : links
          cb(results)
        },
        createFilter1 (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelect_1 (item) {
          this.row1.kode_cabang = item.kode
        },
        querySearchRegion: function (queryString, cb) {
          var links = this.region_.slice()
          var results = queryString ? links.filter(this.createFilterRegion(queryString)) : links
          cb(results)
        },
        createFilterRegion (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelectRegion (item) {
          this.wilayah1 = ''
          this.area1 = ''
          this.cabang1 = ''
          // coba
          this.wilayah_ = this.wilayah.slice()
          this.area_ = this.area.slice()
          this.cabang_ = this.cabang.slice()
          var nama = item.value
          var newArray = this.wilayah.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.region
            // return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            return (nama1.toLowerCase().localeCompare(nama.toLowerCase()) === 0)
          })
          this.wilayah_ = newArray1.slice()
        },
        querySearchWilayah: function (queryString, cb) {
          var links = this.wilayah_.slice()
          var results = queryString ? links.filter(this.createFilterWilayah(queryString)) : links
          cb(results)
        },
        createFilterWilayah (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelectWilayah (item) {
          this.area1 = ''
          this.cabang1 = ''
          this.area_ = this.area.slice()
          this.cabang_ = this.cabang.slice()
          var nama = item.value
          var newArray = this.area.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.wilayah
            // return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            return (nama1.toLowerCase().localeCompare(nama.toLowerCase()) === 0)
          })
          this.area_ = newArray1.slice()
        },
        querySearchArea: function (queryString, cb) {
          var links = this.area_.slice()
          var results = queryString ? links.filter(this.createFilterArea(queryString)) : links
          cb(results)
        },
        createFilterArea (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelectArea (item) {
          this.cabang1 = ''
          this.cabang_ = this.cabang.slice()
          var nama = item.value
          var newArray = this.cabang.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.area
            // return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            return (nama1.toLowerCase().localeCompare(nama.toLowerCase()) === 0)
          })
          this.cabang_ = newArray1.slice()
        },
        handleSelect: function () {
          var nama = this.carinama
          var newArray = this.admin1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            // return (nama1.toLowerCase().localeCompare(nama.toLowerCase()) === 0)
          })
          this.admin = newArray1.slice()
        },
        handleSelect1: function () {
          var nama = this.carinama1
          var newArray = this.admarea1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            // return (nama1.toLowerCase().localeCompare(nama.toLowerCase()) === 0)
          })
          this.admarea = newArray1.slice()
        },
        handleSelect2: function () {
          var nama = this.carinama2
          var newArray = this.kacab1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            // return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            return (nama1.toLowerCase().localeCompare(nama.toLowerCase()) === 0)
          })
          this.kacab = newArray1.slice()
        },
        handleCurrentChangeAdmin (val) {
          // this.row1.nama = val.nama
          this.row1.admin_update = val.nama
          this.row1.kode_admin = val.kode
        },
        querySearchJenis: function (queryString, cb) {
          var links = this.cutoff_jenis.slice()
          var results = queryString ? links.filter(this.createFilterJenis(queryString)) : links
          cb(results)
        },
        createFilterJenis (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelectJenis (item) {
          this.row1.cutoff_jenis_kode = item.kode + ''
        },
        querySearchPajak: function (queryString, cb) {
          var links = this.pajak.slice()
          var results = queryString ? links.filter(this.createFilterPajak(queryString)) : links
          cb(results)
        },
        createFilterPajak (queryString) {
          return (link) => {
            return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
          }
        },
        handleSelectPajak (item) {
          this.row1.kode_pajak = item.kode + ''
        },
        editAdmin (row) {
          this.kode = row.kode
          this.row1.nama = row.admin
          this.dialogFormEditAdmin = true
        },
        editAdmin2 () {
          this.dialogFormEditAdmin = true
        },
        handleCurrentChangeAdmArea (val) {
          // this.row1.nama = val.nama
          this.row1.admin_area_update = val.nama
          this.row1.kode_admin_area = val.kode
        },
        editAdmArea (row) {
          this.kode = row.kode
          this.row1.nama = row.admin_area
          this.dialogFormEditAdmArea = true
        },
        editAdmArea2 () {
          this.dialogFormEditAdmArea = true
        },
        handleCurrentChangeKacab (val) {
          this.row1.nama = val.nama
          this.row1.kode_kacab = val.kode
        },
        editKacab (row) {
          this.kode = row.kode
          this.row1.nama = row.kacab
          this.dialogFormEditKacab = true
        },
        cariNama () {
          var nama = this.cari_nama
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariRegion () {
          var nama = this.cari_region
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.region
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariWilayah () {
          var nama = this.cari_wilayah
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.wilayah
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariArea () {
          var nama = this.cari_area
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.area
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariCabang () {
          var nama = this.cari_cabang
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.cabang
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariAlamat () {
          var nama = this.cari_alamat
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.alamat
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariJenisToko () {
          var nama = this.cari_jenis_toko
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.jenis_toko
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariAdmin () {
          var nama = this.cari_admin
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.admin
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariAdminAdmArea () {
          var nama = this.cari_admin_area
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.admin_area
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariKacab () {
          var nama = this.cari_kacab
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.kacab
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariPajak () {
          var nama = this.cari_pajak + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.pajak + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariRoyalti () {
          var nama = this.cari_royalti + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.royalti + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariKareg () {
          var nama = this.cari_kepala_region
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.kepala_region
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariKawil () {
          var nama = this.cari_kepala_wilayah
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.kepala_wilayah
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariKarea () {
          var nama = this.cari_kepala_area
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.kepala_area
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nama.toLowerCase()
              var y = b.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nama.toLowerCase()
              var y = a.nama.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        resetForm (formName) {
          if (this.$refs[formName] !== undefined) {
            this.$refs[formName].resetFields()
          }
        },
        clearForm: function () {
          this.cutoff_jenis_kode = ''
          this.cutoff_jenis_nama = ''
          this.pajak_kode = ''
          this.pajak_keterangan = ''
          this.value4 = new Date()
          this.row1 = {kode: '', nama: '', royalti: '0', investasi_pembangunan: '0', sewa_toko: '0', kode_cutoff_jenis: '', edit: true, alamat: '', kode_cabang: '', kode_toko_jenis: '', cutoff_jenis_kode: ''}
          this.region1 = ''
          this.region1_ = ''
          this.wilayah1 = ''
          this.area1 = ''
          this.cabang1 = ''
          this.keterangan_pajak = ''
          this.resetForm('formAdd')
          this.resetForm('formEdit')
          this.resetForm('formEditAdmin')
          this.resetForm('formEditAdmArea')
          this.resetForm('formEditKacab')
        },
        confirmDet: function (row) {
          this.$router.push('/area/' + row.kode + '/' + row.nama)
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.value4 = ''
          this.resetForm('formEdit')
          this.row1.kode = row.kode
          this.row1.nama = row.nama
          this.row1.kode_pajak = row.kode_pajak
          this.keterangan_pajak = row.keterangan_pajak
          this.kode_pajak = row.kode_pajak
          this.row1.royalti = row.royalti
          this.row1.alamat = row.alamat
          this.region1 = row.jenis_toko
          this.region1_ = row.region
          this.wilayah1 = row.wilayah
          this.area1 = row.area
          this.cabang1 = row.cabang
          this.row1.investasi_pembangunan = row.investasi_pembangunan
          this.row1.sewa_toko = row.sewa_toko
          this.row1.jatuh_tempo_sewa_toko = row.jatuh_tempo_sewa_toko
          this.cutoff_jenis_nama = row.cutoff_jenis_nama
          this.value4 = row.jatuh_tempo_sewa_toko
          this.row1.kode_cabang = row.kode_cabang + ''
          this.row1.kode_toko_jenis = row.kode_toko_jenis + ''
          this.row1.cutoff_jenis_kode = row.cutoff_jenis_kode + ''
          this.row1.admin = row.admin + ''
          this.row1.admin_area = row.admin_area + ''

          var newArrayWilayah = this.wilayah.slice().filter(function (el) {
            var region = el.region
            // return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            return (region.toLowerCase().localeCompare(row.region.toLowerCase()) === 0)
          })
          this.wilayah_ = newArrayWilayah.slice()

          var newArrayArea = this.area.slice().filter(function (el) {
            var wilayah = el.wilayah
            // return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            return (wilayah.toLowerCase().localeCompare(row.wilayah.toLowerCase()) === 0)
          })
          this.area_ = newArrayArea.slice()

          var newArrayCabang = this.cabang.slice().filter(function (el) {
            var area = el.area
            // return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
            return (area.toLowerCase().localeCompare(row.area.toLowerCase()) === 0)
          })
          this.cabang_ = newArrayCabang.slice()
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              if (row.kode !== '') {
                this.loadingModalEdit = true
              } else {
                this.loadingModalAdd = true
              }
              this.loadingModal = true
              this.dialogFormEdit = false
              this.dialogFormVisible = false

              var req = ''
              var action = '/'
              var TglJatuhTempo = moment(this.value4).format('YYYY-MM-DD')
              if (row.kode !== '') {
                // req = {kode: row.kode, nama: row.nama, alamat: row.alamat, kode_cabang: row.kode_cabang, kode_toko_jenis: row.kode_toko_jenis, pajak: row.pajak, royalti: row.royalti, investasi_pembangunan: row.investasi_pembangunan, sewa_toko: row.sewa_toko, kode_cutoff_jenis: row.cutoff_jenis_kode, jatuh_tempo_sewa_toko: TglJatuhTempo}
                req = {kode: row.kode, nama: row.nama, alamat: row.alamat, kode_cabang: row.kode_cabang, kode_toko_jenis: row.kode_toko_jenis, kode_pajak: row.kode_pajak, royalti: '0.75', investasi_pembangunan: row.investasi_pembangunan, sewa_toko: row.sewa_toko, kode_cutoff_jenis: row.cutoff_jenis_kode, jatuh_tempo_sewa_toko: TglJatuhTempo}
                action += 'update'
              } else {
                // req = {nama: row.nama, alamat: row.alamat, kode_cabang: row.kode_cabang, kode_toko_jenis: row.kode_toko_jenis, pajak: row.pajak, royalti: row.royalti, investasi_pembangunan: row.investasi_pembangunan, sewa_toko: row.sewa_toko, kode_cutoff_jenis: row.cutoff_jenis_kode, jatuh_tempo_sewa_toko: TglJatuhTempo}
                req = {nama: row.nama, alamat: row.alamat, kode_cabang: row.kode_cabang, kode_toko_jenis: row.kode_toko_jenis, kode_pajak: row.kode_pajak, royalti: '0.75', investasi_pembangunan: row.investasi_pembangunan, sewa_toko: row.sewa_toko, kode_cutoff_jenis: row.cutoff_jenis_kode, jatuh_tempo_sewa_toko: TglJatuhTempo}
                action += 'create'
              }
              var req1 = JSON.stringify(req)
              var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEdit = false
                  this.loadingModalAdd = false
                  // this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                  this.loadingModal = false
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEdit = false
                this.loadingModalAdd = false
                this.loadingModal = false
                // this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmEditAdmin1: function (j, row, formName) {
          if (this.row1.kode_admin.trim().length > 0) {
            this.loadingModalEditAdmin = true
            var req = {kode: this.row1.kode, kode_admin: this.row1.kode_admin}
            var req1 = JSON.stringify(req)
            var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/update_admin_toko'

            Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
              if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                this.$router.push('/login')
              } else {
                this.dialogFormWilEdit = false
                this.getData()
                this.loadingModalEditAdmin = false
                this.loadingModalAdd = false
                // this.clearForm()
                this.row1.admin = this.row1.admin_update
                this.dialogFormEditAdmin = false
                // this.message = response.body
                // this.dialogFormInfo = true
              }
            }, response => {
              // error callback
              this.dialogFormWilEdit = false
              this.loadingModalEditAdmin = false
              this.loadingModalAdd = false
              this.clearForm()
            })
          }

          // this.$refs[formName].validate((valid) => {
          //   if (valid) {
          //     this.loadingModalEditAdmin = true
          //     this.dialogFormEditAdmin = false

          //     var req = ''
          //     // req = {kode: this.kode, kode_admin: this.row1.kode_admin}
          //     req = {kode: this.row1.kode, kode_admin: this.row1.kode_admin}
          //     var req1 = JSON.stringify(req)
          //     var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/update_admin_toko'

          //     Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //       if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
          //         this.$router.push('/login')
          //       } else {
          //         this.dialogFormWilEdit = false
          //         this.getData()
          //         this.loadingModalEditAdmin = false
          //         this.loadingModalAdd = false
          //         this.clearForm()
          //         this.message = response.body
          //         this.dialogFormInfo = true
          //       }
          //     }, response => {
          //       // error callback
          //       this.dialogFormWilEdit = false
          //       this.loadingModalEditAdmin = false
          //       this.loadingModalAdd = false
          //       this.clearForm()
          //     })
          //   } else {
          //     return false
          //   }
          // })
        },
        confirmEditAdmArea1: function (j, row, formName) {
          if (this.row1.kode_admin_area.trim().length > 0) {
            this.loadingModalEditAdmArea = true

            var req = ''
            req = {kode: this.row1.kode, kode_admin_area: this.row1.kode_admin_area}
            var req1 = JSON.stringify(req)
            var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/update_admin_area'

            Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
              if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                this.$router.push('/login')
              } else {
                this.dialogFormWilEdit = false
                this.getData()
                this.loadingModalEditAdmArea = false
                this.loadingModalAdd = false
                this.row1.admin_area = this.row1.admin_area_update
                this.dialogFormEditAdmArea = false
                this.message = response.body
                this.dialogFormInfo = true
              }
            }, response => {
              // error callback
              this.dialogFormWilEdit = false
              this.loadingModalEditAdmArea = false
              this.loadingModalAdd = false
              this.clearForm()
            })
          }
          // this.$refs[formName].validate((valid) => {
          //   if (valid) {
          //     this.loadingModalEditAdmArea = true
          //     this.dialogFormEditAdmArea = false

          //     var req = ''
          //     req = {kode: this.kode, kode_admin_area: this.row1.kode_admin_area}
          //     var req1 = JSON.stringify(req)
          //     var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/update_admin_area'

          //     Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //       if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
          //         this.$router.push('/login')
          //       } else {
          //         this.dialogFormWilEdit = false
          //         this.getData()
          //         this.loadingModalEditAdmArea = false
          //         this.loadingModalAdd = false
          //         this.clearForm()
          //         this.message = response.body
          //         this.dialogFormInfo = true
          //       }
          //     }, response => {
          //       // error callback
          //       this.dialogFormWilEdit = false
          //       this.loadingModalEditAdmArea = false
          //       this.loadingModalAdd = false
          //       this.clearForm()
          //     })
          //   } else {
          //     return false
          //   }
          // })
        },
        confirmEditKacab1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loadingModalEditKacab = true
              this.dialogFormEditKacab = false

              var req = ''
              req = {kode: this.kode, kode_kacab: this.row1.kode_kacab}
              var req1 = JSON.stringify(req)
              var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/update_kacab'

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormWilEdit = false
                  this.getData()
                  this.loadingModalEditKacab = false
                  this.loadingModalAdd = false
                  this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                }
              }, response => {
                // error callback
                this.dialogFormWilEdit = false
                this.loadingModalEditKacab = false
                this.loadingModalAdd = false
                this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmOpen: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormOpen = true
        },
        confirmOpen1: function () {
          this.loadingModalOpen = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/open'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormOpen = false
              this.loadingModalOpen = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormOpen = false
            this.loadingModalOpen = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        getData: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var c = this.current_page
          var req = ''
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData = response.body.data.slice()
              this.total = this.tableData.length
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].no = i + 1
                this.tableData[i].pajak += ''
                this.tableData[i].royalti += ''
              }
              this.tableData2 = this.tableData.slice()
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData1.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.toko_jenis + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.region[i].kode = this.region[i].kode + ''
                this.region[i].value = this.region[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.region + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.region_ = response.body.data.slice()
              for (var i = 0; i < this.region_.length; i++) {
                this.region_[i].kode = this.region_[i].kode + ''
                this.region_[i].value = this.region_[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.wilayah + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.wilayah = response.body.data.slice()
              for (var i = 0; i < this.wilayah.length; i++) {
                this.wilayah[i].kode = this.wilayah[i].kode + ''
                this.wilayah[i].value = this.wilayah[i].nama + ''
              }
              this.wilayah_ = this.wilayah.slice()
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.area + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.area = response.body.data.slice()
              for (var i = 0; i < this.area.length; i++) {
                this.area[i].kode = this.area[i].kode + ''
                this.area[i].value = this.area[i].nama + ''
              }
              this.area_ = this.area.slice()
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.cabang + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.cabang = response.body.data.slice()
              for (var i = 0; i < this.cabang.length; i++) {
                this.cabang[i].kode = this.cabang[i].kode + ''
                this.cabang[i].value = this.cabang[i].nama + ''
              }
              this.cabang_ = this.cabang.slice()
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/list_pajak'
          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.pajak = response.body.data.slice()
              for (var i = 0; i < this.region.length; i++) {
                this.pajak[i].kode = this.pajak[i].kode + ''
                this.pajak[i].value = this.pajak[i].keterangan_pajak + ''
              }
            }
          }, response => {
            // error callback
          })

          this.links = []

          url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/list_admin_toko'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.admin = response.body.data.slice()
              for (var i = 0; i < this.admin.length; i++) {
                this.admin[i].kode = this.admin[i].kode + ''
                this.links.push({value: this.admin[i].nama, kode: this.admin[i].kode})
              }
              this.admin1 = this.admin.slice()
            }
          }, response => {
            // error callback
          })

          url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/list_admin_area'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.admarea = response.body.data.slice()
              for (var i = 0; i < this.admarea.length; i++) {
                this.admarea[i].kode = this.admarea[i].kode + ''
              }
              this.admarea1 = this.admarea.slice()
            }
          }, response => {
            // error callback
          })

          // req = {}
          // req1 = JSON.stringify(req)

          // url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/notifikasi'
          // // console.log(localStorage.session)

          // Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //   // console.log('response ' + response.body[0].nama)
          //   if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
          //     this.$router.push('/login')
          //   } else {
          //     this.loadingModal = false
          //     this.notif = response.body.data.slice()
          //     for (var i = 0; i < this.notif.length; i++) {
          //       // var msg = this.notif[i].message
          //       setTimeout(() => this.openNotif(), (1000 * i))
          //     }
          //   }
          // }, response => {
          //   // error callback
          //   this.loadingModal = false
          // })

          // url = Vue.cookie.get('url') + '/' + jsonUrl.toko + '/list_kacab'
          // // console.log(localStorage.session)

          // Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
          //   // console.log('response ' + response.body[0].nama)
          //   if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
          //     this.$router.push('/login')
          //   } else {
          //     this.kacab = response.body.data.slice()
          //     for (var i = 0; i < this.kacab.length; i++) {
          //       this.kacab[i].kode = this.kacab[i].kode + ''
          //     }
          //     this.kacab1 = this.kacab.slice()
          //   }
          // }, response => {
          //   // error callback
          // })
        },
        getDataJenis: function () {
          var url = Vue.cookie.get('url') + '/' + jsonUrl.cutoff_jenis + '/read'

          Vue.http.post(url, '', {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.cutoff_jenis = response.body.data.slice()
              for (var i = 0; i < this.cutoff_jenis.length; i++) {
                this.cutoff_jenis[i].kode = this.cutoff_jenis[i].kode + ''
                this.cutoff_jenis[i].value = this.cutoff_jenis[i].nama + ''
              }
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {
        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        this.loadingModal = true
        this.getData()
        this.getDataJenis()
      }
    }
</script>

<style>
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// Toko1.vue?cd8aa42e